"use client"

import type { ReactNode } from "react"
import { Button } from "@ui/shad"
import { cn } from "@ui/utils"
import { Minimize } from "lucide-react"

export function PresentationControls({
  visible,
  onActivity,
  onExit,
  children,
}: {
  visible: boolean
  onActivity: () => void
  onExit: () => void
  children?: ReactNode
}) {
  return (
    <div
      role="toolbar"
      aria-label="Presentation controls"
      onPointerMove={onActivity}
      onFocusCapture={onActivity}
      className={cn(
        "bg-popover text-popover-foreground fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-lg border p-2 shadow-lg transition-opacity focus-within:opacity-100 hover:opacity-100",
        visible ? "opacity-100" : "opacity-0"
      )}
    >
      {children}
      <Button size="sm" variant="ghost" onClick={onExit}>
        <Minimize /> Exit presentation
      </Button>
    </div>
  )
}
